import { getApi } from '../../utils/api'

export function getInhabitantsFromContractIDOptions(params) {
  return getApi({
    endpoint: `idwell-api/api/v3/inhabitancy/contract-options/`,
    params,
  })
}
